// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.HelpSystem.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import { observable } from 'mobx';
import ContextMenuStore from 'logic/Izenda.ContextMenuStore';
import connect from 'share/enhancers/Izenda.Connect';

class HelpSystem extends Component {
  @observable helpSystemUrl = '';

  constructor() {
    super();

    this.store = new ContextMenuStore();
  }

  componentDidMount() {
    return this.store.getHelpSystemUrl().then(url => {
      this.helpSystemUrl = url;
    });
  }

  render() {
    const helpSystemUrl = this.helpSystemUrl;
    const { localization } = this.props;

    return !!helpSystemUrl ? (
      <div className='izenda-UserMenu-Bell u_fullInlineBlock'>
        <div className='u-posRelative'>
          <a
            href={helpSystemUrl}
            target='_blank'
            rel='noopener noreferrer'
            title={localization.getText('COMMON_LABEL_HELP_SYSTEM')}
            className='icon-info-circled-alt u_LargeIcon u-colorBlack'
          />
        </div>
      </div>
    ) : null;
  }
}

export default connect()(HelpSystem);



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.HelpSystem.js